import { AddEnginePresetContainer } from "./container";

export const AddEnginePresetPane = () => {
  return <AddEnginePresetContainer />;
};
